module.exports = __webpack_public_path__ + "img/sad-face.4756dee3.png";